export const BorderWithRadius = (color: String) => {
  return `border:2px solid #${color};
  border-radius: 4px;`
}

export const BoxShadowWithRadius = (color: String, inset:Boolean = true) => {
  return `box-shadow: ${inset ? 'inset' : ''} 0 0 0 2px #${color};
    border-radius:4px;`
};

export const BoxShadowWithRadiusAndSpace = (backgroundColor: String, color: String) => {
  return `box-shadow: 0 0 0 2px #${backgroundColor}, 0 0 0 4px #${color};
    border-radius:4px;`
};

export const BeforePseudoIconBorder = (color: String, iconSize: Number, topOffset = -6, leftOffset = -6) => {
  return `border: 2px solid #${color};
    border-radius:4px;
    content:" ";
    position:absolute;
    left:${leftOffset}px;
    top:${topOffset}px;
    width:${iconSize}px;
    height:${iconSize}px;`
};

export const OutlineWithRadius = (color: String) => {
  return `border-radius:4px;
    outline: 2px solid #${color};`
}
